import { useQuery } from "@tanstack/react-query";
import EnumSelect from "./EnumSelect";
import { fetchDisabilityPensionTypeList } from "@/services/disabilityPensionType";
import { useTranslation } from "react-i18next";
import { forwardRef } from "react";
import { ControllerRenderProps } from "react-hook-form";
import { Module } from "@/constants";

interface DisabilityPensionTypeSelectProps extends ControllerRenderProps {
  className?: string;
}

export default forwardRef<HTMLButtonElement, DisabilityPensionTypeSelectProps>(
  function DisabilityPensionTypeSelect(props, ref) {
    const { t } = useTranslation();
    const query = useQuery({
      queryKey: [Module.DisabilityPensionTypes],
      queryFn: () => fetchDisabilityPensionTypeList(),
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    });

    return (
      <EnumSelect
        options={query.data || []}
        translationKey="disabilityPensionTypes"
        placeholder={t("disabilityPensionTypeSelect.placeholder")}
        disabled={props.disabled || query.isFetching || query.isError}
        {...props}
        ref={ref}
      />
    );
  },
);
